<script>
export default {
  name: "wxm-session-expired",

  created() {
    this.$alert(boi18n.getMessage({
      bundleName: "/bov3/wcm",
      key: "veuillez_vous_reconnecter",
    }), boi18n.getMessage({
      bundleName: "/bov3/wcm",
      key: "expired_session",
    }), {
      confirmButtonText: boi18n.getMessage({
        bundleName: "/bov3/wcm",
        key: "login_connexion",
      }),
      showClose: false,
      roundButton: true,
      callback: action => {
        window.location.reload()
      }
    });
  }
}
</script>
